import {doScrolling, getCoords} from '../utils/utils';
import {UserScroll} from '../utils/user-scroll';

const RANGE = {
  OPACITY: {
    MIN: 0,
    MID: 1,
    MAX: 0,
  },
  TRANSLATE: {
    MIN: 40,
    MID: 0,
    MAX: -40,
  },
  PHONE_SCALE: {
    MIN: 0.7,
    MAX: 1,
  },
};

const docEl = document.documentElement;
let currentWidth = null;

let scaleElement;
let bgElement;
let nextElement;
let userScroll = false;
let isLastSlideTransActive = false;

const returnSlidesHeightSum = (arr) => {
  let height = 0;
  arr.forEach((el) => {
    height += el.scrollHeight;
  });
  return height;
};

const setSliderHeight = (slider, slides) => {
  const sliderHeight = returnSlidesHeightSum(slides);
  slider.style.height = `${sliderHeight}px`;
};

const changeEffects = (slide, opacity, translate, elementScale, elementOpacity) => {
  const box = slide.querySelector('.scroll-sequence__slide-box');

  if (!box) {
    return;
  }

  box.style.opacity = opacity;
  box.style.transform = `translate3d(0, ${translate}px, 0)`;

  if (scaleElement && typeof elementScale === 'number') {
    scaleElement.style.transform = `scale(${elementScale})`;
  }
  if (bgElement && typeof elementOpacity === 'number') {
    bgElement.style.opacity = elementOpacity;
  }
};

const animateSlides = (slider, slide, slidesLength, index, heightPoints) => {
  const halfHeightPoints = heightPoints / 2;
  const diffSlide = Math.abs(slider.getBoundingClientRect().top - (-(index) * heightPoints - halfHeightPoints));
  let diffOpacity;
  let diffTranslate;

  if (slider.getBoundingClientRect().top > -(index) * heightPoints - halfHeightPoints) {
    if (index !== 0) {
      diffOpacity = RANGE.OPACITY.MID - RANGE.OPACITY.MIN;
      diffTranslate = RANGE.TRANSLATE.MIN - RANGE.TRANSLATE.MID;
    }
  } else {
    if (index !== slidesLength - 1) {
      diffOpacity = RANGE.OPACITY.MID - RANGE.OPACITY.MAX;
      diffTranslate = RANGE.TRANSLATE.MAX - RANGE.TRANSLATE.MID;
    }
  }

  const oneOpacity = diffOpacity / halfHeightPoints;
  const oneTranslate = diffTranslate / halfHeightPoints;

  const opacity = 1 - oneOpacity * diffSlide;
  const translate = oneTranslate * diffSlide;

  let phoneScale = false;
  let bgOpacity = false;

  if (index === slidesLength - 2) {
    const diffScale = RANGE.PHONE_SCALE.MAX - RANGE.PHONE_SCALE.MIN;
    const diffBgOpacity = RANGE.OPACITY.MID - RANGE.OPACITY.MIN;
    const oneScale = diffScale / heightPoints;
    const oneBgOpacity = diffBgOpacity / heightPoints;
    phoneScale = 1 - oneScale * (Math.abs(
        slider.getBoundingClientRect().top - (-(index) * heightPoints)
    ));
    bgOpacity = oneBgOpacity * (heightPoints - (Math.abs(
        slider.getBoundingClientRect().top - (-(index) * heightPoints)
    )));
  } else if (index > slidesLength - 2) {
    bgOpacity = RANGE.OPACITY.MIN;
  }

  changeEffects(slide, opacity, translate, phoneScale, bgOpacity);
};

const changeSlides = (slider, slides, slidesLength, isFirst = false) => {
  const points = slidesLength + 1;
  const heightPoints = slider.getBoundingClientRect().height / points;

  if (slider.getBoundingClientRect().top >= 0) {
    if (slider.classList.contains('js-in-view')) {
      slider.classList.remove('js-in-view');
    }
    slides[0].classList.add('is-active');
    slides.forEach((slide, index) => {
      if (index === 0) {
        changeEffects(
            slide,
            RANGE.OPACITY.MID,
            RANGE.TRANSLATE.MID,
            RANGE.PHONE_SCALE.MAX,
            RANGE.OPACITY.MID
        );
      } else {
        changeEffects(
            slide,
            RANGE.OPACITY.MIN,
            RANGE.TRANSLATE.MIN,
            RANGE.PHONE_SCALE.MAX,
            RANGE.OPACITY.MID
        );
      }
    });
  }

  if (slider.getBoundingClientRect().bottom <= window.innerHeight) {
    if (nextElement && userScroll) {
      if (
        !isLastSlideTransActive
        && slider.classList.contains('js-in-view')
        && nextElement.classList.contains('js-out-of-view')
        && slider.getBoundingClientRect().bottom < window.innerHeight
      ) {
        const position = getCoords(nextElement).top;
        isLastSlideTransActive = true;
        doScrolling(position, 1000, () => {
          nextElement.classList.remove('js-out-of-view');
          userScroll.enableScrolling();
          isLastSlideTransActive = false;
        });
        slider.classList.remove('js-in-view');
      }

      if (
        !isLastSlideTransActive
        && nextElement.getBoundingClientRect().top > 1
        && !nextElement.classList.contains('js-out-of-view')
      ) {
        const position = getCoords(nextElement).top - window.innerHeight;
        userScroll.disableScrolling();
        isLastSlideTransActive = true;
        doScrolling(position, 1000, () => {
          slider.classList.add('js-in-view');
          userScroll.enableScrolling();
          isLastSlideTransActive = false;
        });
        nextElement.classList.add('js-out-of-view');
      }
    }

    slides[slides.length - 1].classList.add('is-active');
    slides.forEach((slide, index, arr) => {
      if (index === arr.length - 1) {
        changeEffects(
            slide,
            RANGE.OPACITY.MID,
            RANGE.TRANSLATE.MID,
            RANGE.PHONE_SCALE.MIN,
            RANGE.OPACITY.MIN
        );
      } else {
        changeEffects(
            slide,
            RANGE.OPACITY.MAX,
            RANGE.TRANSLATE.MAX,
            RANGE.PHONE_SCALE.MIN,
            RANGE.OPACITY.MIN
        );
      }
    });
  }

  if (slider.getBoundingClientRect().bottom > window.innerHeight && slider.getBoundingClientRect().top < 0) {
    slider.classList.add('js-in-view');
    if (nextElement) {
      nextElement.classList.add('js-out-of-view');
    }

    slides.forEach((slide, index) => {
      if (slider.getBoundingClientRect().top + index * heightPoints < 0 && slider.getBoundingClientRect().top > -(index + 1) * heightPoints) {
        const activeSlide = slider.querySelector('.scroll-sequence__slide.is-active');
        if (activeSlide && activeSlide !== slide) {
          activeSlide.classList.remove('is-active');
          slide.classList.add('is-active');
        } else {
          animateSlides(slider, slide, slidesLength, index, heightPoints);
          slide.classList.add('is-active');
        }
      }
    });
  }

  if (isFirst) {
    if (slider.getBoundingClientRect().bottom > window.innerHeight && slider.getBoundingClientRect().top < 0) {
      const currentIndex = Array.from(slides).findIndex((currentSlide) => {
        return currentSlide.classList.contains('is-active');
      });
      slides.forEach((slide, index) => {
        if (index < currentIndex) {
          changeEffects(
              slide,
              RANGE.OPACITY.MAX,
              RANGE.TRANSLATE.MAX,
              RANGE.PHONE_SCALE.MIN,
              RANGE.OPACITY.MIN
          );
        } else if (index > currentIndex) {
          changeEffects(
              slide,
              RANGE.OPACITY.MIN,
              RANGE.TRANSLATE.MIN,
              RANGE.PHONE_SCALE.MAX,
              RANGE.OPACITY.MID
          );
        }
      });
    }
  }
};

const initScrollSequence = () => {
  const slider = document.querySelector('.scroll-sequence');
  scaleElement = document.querySelector('.js-scale-element');
  bgElement = document.querySelector('.js-opacity');

  if (!slider) {
    return;
  }

  nextElement = slider.nextElementSibling;

  if (nextElement) {
    userScroll = new UserScroll();
    userScroll.init();
  }

  slider.classList.add('js-active');
  const slides = slider.querySelectorAll('.scroll-sequence__slide');
  const slidesLength = slides.length;
  setSliderHeight(slider, slides);
  setTimeout(function () {
    changeSlides(slider, slides, slidesLength, true);
  }, 100);


  currentWidth = docEl.clientWidth;
  window.addEventListener('resize', () => {
    const newWidth = docEl.clientWidth;
    if (newWidth === currentWidth) {
      return;
    }

    currentWidth = newWidth;

    setTimeout(function () {
      setSliderHeight(slider, slides);
      changeSlides(slider, slides, slidesLength);
    }, 100);
  });

  window.addEventListener('scroll', () => {
    changeSlides(slider, slides, slidesLength);
  });
};

export {initScrollSequence};
